import { memo, useCallback, useLayoutEffect, useState } from "react"
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap"
import { Controller, FormProvider, useForm } from "react-hook-form"
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import SwalMessage from "../_Components/SwalMessage";
import PromoCode from "../../../core/api/api.promoCode"
import _ from "lodash";
import { numberRegex, tools } from "../../../core/utils/tools";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiPromoCategory from "../../../core/api/api.promocategory";

const CreateOrUpdatePromoCodeModal = ({
  selectedPromoCode,
  setSelectedPromoCode,
  showCreateModal,
  setShowCreateModal,
  allAgentList
}) => {
  const [promoCodes, setPromoCodes] = useState([]);
  const {
    formattedToday,
    formattedArbitaryDate: formatted21DaysFromNow,
  } = tools.setCustomDate(21);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      agentId: selectedPromoCode ? { label: selectedPromoCode?.agent.companyName, value: selectedPromoCode?.agent.id } : null,
      promoCategoryId: selectedPromoCode
        ? {
          value: selectedPromoCode.promoCategoryId,
          label: selectedPromoCode.promoCategoryId + "-" + selectedPromoCode.promoCategoryS
        }
        : null,
      expireDate: selectedPromoCode?.expireDate || formatted21DaysFromNow,
      isDeleted: typeof !selectedPromoCode?.isDeleted == "boolean" ? !selectedPromoCode?.isDeleted : true,
      userCheckInDate: selectedPromoCode?.promoCodeUser[0]?.userCheckInDate || formattedToday,
      userCheckOutDate: selectedPromoCode?.promoCodeUser[0]?.userCheckOutDate || formatted21DaysFromNow,
      passengersCount: selectedPromoCode?.promoCodeUser[0]?.passengersCount || 0,
      userPhoneNumber: selectedPromoCode?.promoCodeUser[0]?.userPhoneNumber,
      userFirstName: selectedPromoCode?.promoCodeUser[0]?.userFirstname,
      userLastName: selectedPromoCode?.promoCodeUser[0]?.userLastName,
      code: selectedPromoCode?.code,
      promoCodeId: selectedPromoCode?.id,
    }
  });
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  useLayoutEffect(() => {
    if (!selectedPromoCode) {
      setValue("promoCategoryId", null)
      if (!!getValues("agentId") && !_.isArray(getValues("agentId")))
        (async () => {
          const promoCategoryList = await ApiPromoCategory.getAllPromoCategoryByAgentId({ id: getValues("agentId")?.value, promoCategoryType: 1 });
          setPromoCodes(promoCategoryList);
        })()
    }
  }, [watch("agentId"), selectedPromoCode, setValue])
  const onSubmit = useCallback(async (data) => {
    try {
      if (!_.isUndefined(data.promoCategoryId) && !_.isEmpty(data.promoCategoryId)) data.promoCategoryId = data?.promoCategoryId?.value;
      if (!_.isUndefined(data.agentId) && !_.isEmpty(data.agentId)) data.agentId = data?.agentId?.value;
      data.expireDate = tools.dateConverter(data.expireDate)
      data.userCheckInDate = tools.dateConverter(data.userCheckInDate)
      data.userCheckOutDate = tools.dateConverter(data.userCheckOutDate)
      data.isDeleted = !data.isDeleted
      let response = await PromoCode.createOrEditPrivatePromoCode(data);
      SwalMessage({ title: response?.message, iSsuccess: response?.succeeded });
      if (response?.succeeded) {
        document.getElementById("submitButton").click();
        handleClose();
      }
    } catch (error) {
      console.log("error=", error);
    }
  }, [selectedPromoCode])
  const handleClose = useCallback(() => {
    setSelectedPromoCode(null)
    setShowCreateModal(false)
  }, [setSelectedPromoCode, setShowCreateModal])

  const copyToClipBoard = useCallback(async (copyMe) => {
    try {
      await navigator.clipboard.writeText(copyMe);
      SwalMessage({ title: "کد تخفیف کپی شد", iSsuccess: true, timer: 10000 });
    } catch (err) {
    }
  }, []);
  return (
    <div>
      <Modal centered size="md" show={!!selectedPromoCode || showCreateModal} onHide={handleClose}>
        <FormProvider {...methods}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title>{!!selectedPromoCode ? "ویرایش کد تخفیف خصوصی" : "ایجاد کد تخفیف خصوصی"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {selectedPromoCode &&
                <Col xs="12">
                  <Controller
                    className="mt-5"
                    name="code"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { value, onChange } }) => (
                      <div className="d-flex align-items-center">
                        <TextField
                          label="کد تخفیف"
                          margin="normal"
                          variant="outlined"
                          disabled
                          size="small"
                          value={value}
                          onChange={onChange}
                        />
                        <span
                          className="btn btn-light-primary btn-sm mr-2 btn-icon mt-2 ml-2 "
                          onClick={(e) => copyToClipBoard(getValues("code"))}
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-custom-class="tooltip-dark"
                          title="کپی تو کلیپ بورد"
                          data-bs-delay-hide="1000"
                        >
                          <i className="fas fa-clipboard"></i>
                        </span>
                      </div>
                    )}
                  />
                </Col>
              }
              <Col xs="12">
                <Controller
                  name="agentId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => {
                    return (
                      <SelectComponent
                        options={allAgentList?.map((item) => ({
                          value: item.id,
                          label: item.companyName,
                        }))}
                        placeholder="نماینده فروش"
                        className="mt-5"
                        isDisabled={!!selectedPromoCode}
                        field={field}
                      />
                    )
                  }}
                />
                {errors.agentId && <div className="mt-2 pl-4 text-danger">**لطفا نماینده را وارد نمایید</div>}

                <Controller
                  name="promoCategoryId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <SelectComponent
                      placeholder="گروه تخفیف"
                      className="mt-5"
                      options={promoCodes?.map((item) => ({
                        value: item.promoCategoryId,
                        label: item.promoCategoryId + "-" + item.promoCategoryName,
                      }))}
                      isDisabled={!!selectedPromoCode}
                      noOptionsMessage={() => <div>{getValues("agentId") ? "نماینده انتخابی هیچ گروه تخفیفی ندارد" : "اول نماینده را انتخاب نمایید"}</div>}
                      field={field}
                    />
                  )}
                />
                {errors.promoCategoryId && <div className="mt-2 pl-4 text-danger">**لطفا گروه تخفیف را وارد نمایید</div>}
                <Controller
                  className="mt-5"
                  name="userPhoneNumber"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { value, onChange } }) => (
                    <TextField
                      label="شماره همراه گردشگر"
                      margin="normal"
                      variant="outlined"
                      disabled={!!selectedPromoCode}
                      size="small"
                      value={value || ""}
                      onChange={(event) => {
                        if ((!numberRegex.test(event.target?.value) && event.target?.value) || event.target?.value?.length > 11) {
                          event.target.value = getValues("userPhoneNumber") || ""
                          return
                        }
                        onChange(event)
                      }}
                    />
                  )}
                />
                {errors.userPhoneNumber && <div className="mt-2 pl-4 text-danger">**لطفا شماره همراه گردشگر را وارد نمایید</div>}
                <Controller
                  name="expireDate"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <ShamsiDatePicker
                      value={value}
                      className="mt-5"
                      placeholder="تاریخ انقضا"
                      onChange={(date) => {
                        var expireDate = getValues("expireDate");
                        onChange(date);
                        if (
                          !expireDate ||
                          (date?.toDate && date?.toDate()?.getTime() > new Date(expireDate).getTime())
                        ) {
                          setValue("expireDate", date);
                        }
                      }}
                    />
                  )}
                />
                {errors.expireDate && (
                  <div className="text-danger mt-2"> ** تاریخ انقضا را انتخاب کنید</div>
                )}
                <Row>
                  <Col>
                    <Controller
                      className="mt-5"
                      name="userFirstName"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          label="نام گردشگر"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                  </Col>
                  <Col>
                    <Controller
                      className="mt-5"
                      name="userLastName"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          label="نام خانوادگی گردشگر"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Controller
                      name="userCheckInDate"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <ShamsiDatePicker
                          value={value}
                          className="mt-5"
                          placeholder="تاریخ ورود"
                          onChange={(date) => {
                            var userCheckInDate = getValues("userCheckInDate");
                            onChange(date);
                            if (
                              !userCheckInDate ||
                              (date?.toDate && date?.toDate()?.getTime() > new Date(userCheckInDate).getTime())
                            ) {
                              setValue("userCheckInDate", date);
                            }
                          }}
                        />
                      )}
                    />
                  </Col>

                  <Col>
                    <Controller
                      name="userCheckOutDate"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <ShamsiDatePicker
                          value={value}
                          className="mt-5"
                          placeholder="تاریخ خروج"
                          onChange={(date) => {
                            var userCheckOutDate = getValues("userCheckOutDate");
                            onChange(date);
                            if (
                              !userCheckOutDate ||
                              (date?.toDate && date?.toDate()?.getTime() > new Date(userCheckOutDate).getTime())
                            ) {
                              setValue("userCheckOutDate", date);
                            }
                          }}
                        />
                      )}
                    />
                  </Col>
                </Row>

                <Row className="mt-5 align-items-center">
                  <Col>
                    <Controller
                      name="passengersCount"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <TextField
                          label="تعداد مسافران بزرگسال"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          type="number"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                  </Col>
                  <Col className="pt-5">
                    <FormControlLabel
                      control={
                        <Controller
                          control={control}
                          name="isDeleted"
                          render={({ field: { onChange, value, ref } }) => (
                            <Checkbox
                              color="primary"
                              onChange={onChange}
                              checked={value || false}
                              inputRef={ref} />
                          )}
                        />
                      }
                      label="فعال"
                    />
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </FormProvider>

      </Modal>
    </div>
  )
}

export default memo(CreateOrUpdatePromoCodeModal)